var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:[_vm.$props.value === _vm.selectedValueInner && 'selected', 'dz-select-option'],on:{"click":_vm.clickHandler}},[_vm._v(" "+_vm._s(_vm.$props.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }